import { B2bMigratedCampaignsShow } from '@sh4res/bo-common/components/B2bCampaigns/B2bMigratedCampaignsShow';

import { ResourceDefinition } from '@Utils/types';

export const migratedCampaignsResource: ResourceDefinition = {
  options: { label: 'menu.collective_operations' },
  show: (props) => <B2bMigratedCampaignsShow {...props} />,
};
